{
  "login": {
    "welcomeTitle": "Welcome",
    "welcomeSubtitle": "Sign in to your account",
    "backHome": "Back to home",
    "heroTitle": "Your Path of Light continues",
    "heroText": "Welcome back. Sign in to your account to continue your practices, connect with the Masters and keep moving along the Path of Light. We're glad to see you again.",
    "statusPrefix": "Your path continues — ",
    "statusName": "Sign in",
    "formTitle": "Welcome back",
    "formText": "Continue your Path of Light. Discover new practices, gatherings and knowledge.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "••••••••",
    "forgotPassword": "Forgot password?",
    "submit": "Sign in",
    "passkey": "Sign in with passkey",
    "passkeyUnavailable": "Passkey sign-in isn't available yet. Use email and password.",
    "newToAgape": "Don't have an account?",
    "createAccount": "Create account",
    "errorCodeLabel": "Error code",
    "errorCodeHint": "Give it to support — it points them straight at what failed.",
    "errorCodeCopy": "Copy code",
    "errorCodeCopied": "Code copied"
  },
  "passkeyErrors": {
    "domainMismatch": "Passkey sign-in doesn't work at this address. Sign in with email and password.",
    "notSupported": "This browser doesn't support passkeys. Sign in with email and password.",
    "alreadyRegistered": "This passkey is already connected on this device.",
    "failed": "Couldn't sign in with passkey. Try again or sign in with email and password.",
    "enrolFailed": "Couldn't connect the passkey. Try again a little later."
  },
  "register": {
    "backHome": "Back to home",
    "heroTitle": "Your Path of Light begins here",
    "heroTitlePlain": "Welcome to Agapella",
    "heroText": "Create an account to explore practices, meet the Agape Masters and kindred people — gradually finding what will support you on your own path.",
    "statusPrefix": "Your first status — ",
    "statusName": "Seeker",
    "successNamePlain": "to Agapella",
    "formTitle": "Create account",
    "formText": "For now, only the essentials.\nYou can tell us more about your interests later.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "At least 8 characters",
    "passwordHelper": "At least 8 characters, an uppercase letter and a digit",
    "confirmPasswordLabel": "Confirm password",
    "generatePassword": "Generate a strong password",
    "submit": "Begin the Path of Light",
    "submitPlain": "Create account",
    "retry": "Try again",
    "formError": "Couldn't create the account. Please try again.",
    "alreadyHaveAccount": "Already have an account?",
    "signIn": "Sign in",
    "welcomeTitle": "Welcome,",
    "successLead": "Today your Path of Light begins.",
    "successLeadPlain": "Your account is ready.",
    "successText": "Explore the platform at your own pace, meet new knowledge and people — Agapella will be nearby to help you take your first steps.",
    "successButton": "Enter the Agapella space",
    "successNext": "Next — meet Agapella on the home page",
    "togglePassword": "Show or hide password",
    "or": "or",
    "signInWithApple": "Sign in with Apple",
    "resendConfirmation": "Resend confirmation email",
    "resending": "Sending...",
    "resendSuccess": "Confirmation email sent. Check your inbox.",
    "checkMailTitle": "Check your email",
    "checkMailLead": "We sent a message to {{email}}. Follow the link inside to confirm your address.",
    "checkMailHint": "No email? Check Promotions and Spam — it sometimes lands there.",
    "changeEmail": "Use a different address",
    "resendIn": "You can resend in {{seconds}}s",
    "openInApp": "Open in the app",
    "nativeTitle": "Create an account",
    "nativeSubtitle": "Fill in your details to sign up",
    "nameLabel": "Name",
    "confirmedTitle": "Email confirmed",
    "confirmedLead": "Your account is active. Sign in to get started.",
    "checkMailNative": "We've sent a confirmation email to {{email}}. Follow the link to activate your account.",
    "signInWithGoogle": "Sign in with Google",
    "googleNoToken": "Google returned no id_token",
    "googleFailed": "Couldn't sign in with Google",
    "appleNoToken": "Apple returned no identityToken",
    "appleFailed": "Couldn't sign in with Apple"
  },
  "forgotPassword": {
    "overline": "Account Recovery",
    "title": "Reset",
    "titleHighlight": "Password",
    "subtitle": "Enter your email to receive recovery instructions",
    "formTitle": "Reset password",
    "formText": "Enter the email you signed up with and we'll send you a link to restore access.",
    "emailLabel": "Email",
    "emailPlaceholder": "your@email.com",
    "submit": "Send reset link",
    "remembered": "Remember now?",
    "signIn": "Sign in",
    "successTitle": "Check your email",
    "successMessage": "We've sent a recovery link to",
    "successHint": "Follow the instructions to reset your password.",
    "returnToLogin": "Return to sign in",
    "tryAnother": "Try another email",
    "nativeTitle": "Password recovery",
    "nativeSubtitle": "Enter your email to get reset instructions",
    "nativeSubmit": "Send instructions",
    "nativeSuccessText": "If an account with {{email}} exists, we've sent password reset instructions to it.",
    "rememberedPassword": "Remembered your password?"
  },
  "resetPassword": {
    "overline": "Security",
    "title": "New",
    "titleHighlight": "Password",
    "subtitle": "Create a strong and secure password for your account",
    "newPasswordLabel": "New Password",
    "newPasswordPlaceholder": "Create a new password",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Repeat new password",
    "submit": "Confirm",
    "cancelLabel": "Cancel?",
    "returnToLogin": "Return to sign in",
    "expiredTitle": "Link Expired",
    "expiredMessage": "This password reset link is invalid or has expired.",
    "requestNewLink": "Request new link",
    "successTitle": "Done!",
    "successMessage": "Your password has been updated. You can now sign in with new credentials.",
    "goToLogin": "Go to sign in",
    "invalidTitle": "Invalid link",
    "invalidMessage": "This password reset link has expired or is incorrect. Request a new one.",
    "changedTitle": "Password changed",
    "changedMessage": "You can now sign in with your new password.",
    "orTypeOwn": "or type your own"
  },
  "confirmEmail": {
    "verifying": "Verifying your email…",
    "signIn": "Sign in",
    "failedTitle": "Verification failed",
    "returnHome": "Return home",
    "alreadyTitle": "Email already confirmed",
    "alreadyMessage": "Nothing to do here — just sign in.",
    "expiredTitle": "This link has expired",
    "expiredMessage": "Links are valid for 24 hours. Request a new email — it goes to the same address.",
    "requestNew": "Request a new email",
    "invalidTitle": "That link did not work",
    "invalidMessage": "It may have been cut short by your mail app or copied only in part. Request a new email — it will go to the same address.",
    "backToSignIn": "I already have an account"
  },
  "validation": {
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "passwordRequired": "Password is required",
    "passwordMinLength": "Password must be at least 6 characters",
    "passwordWeak": "At least 8 characters, one uppercase letter and one digit. Latin characters only",
    "confirmPasswordRequired": "Please confirm your password",
    "passwordsMismatch": "Passwords do not match",
    "loginFailed": "Login failed. Please try again.",
    "emailTaken": "This email is already registered.",
    "registerFailed": "Registration failed. Please try again.",
    "resetFailed": "Failed to reset password. The link may have expired.",
    "resetLinkInvalid": "This link is invalid or has expired. Please request a new password reset.",
    "verifyLinkInvalid": "The verification link is malformed or missing required components.",
    "verifyFailed": "Verification failed. The link may have expired."
  },
  "apiErrors": {
    "invalidEmail": "Invalid email format",
    "emailAlreadyExists": "This email is already registered.",
    "weakPassword": "Password is too weak. At least 8 characters, one uppercase letter and one digit.",
    "registrationFailed": "Registration failed. Please try again.",
    "rateLimitExceeded": "Too many attempts. Please wait a moment and try again.",
    "invalidSocialToken": "Couldn't verify the sign-in. Please try again.",
    "invalidCredentials": "Wrong email or password.",
    "emailNotConfirmed": "This email isn't confirmed yet. Check your inbox for the confirmation link.",
    "accountBlocked": "Access to this account is closed. Write to info@agapella.io and we'll sort it out.",
    "consentRequired": "To continue, accept the Terms of Use and the Privacy Policy.",
    "ageRequired": "Choose your age to continue.",
    "ageNotAllowed": "You must be 14 to register."
  },
  "legal": {
    "consentPrefix": "I accept the ",
    "loginPrefix": "By signing in you accept the ",
    "terms": "Terms of Use",
    "consentMid": " and the ",
    "privacy": "Privacy Policy",
    "consentA11y": "Accept the Terms of Use and the Privacy Policy",
    "pdPrefix": "By checking this box, I accept the ",
    "pdConsentMid": ", confirm that I have read them, and give my ",
    "pdConsent": "consent to the processing of personal data",
    "pdPolicyMid": ". Learn more about how data is processed in the ",
    "pdPolicy": "Privacy Policy",
    "pdSuffix": ".",
    "consentA11yPd": "Accept the Terms of Use and give consent to the processing of personal data",
    "marketingConsent": "I consent to receiving advertising from JSC «Tsifrovaya II Transformatsiya»",
    "marketingConsentLink": "consent to receiving advertising",
    "zeroTolerance": "We have zero tolerance for objectionable content and abusive users: reports are handled within 24 hours, the content is removed and its author is ejected.",
    "mustAccept": "Please accept the Terms of Use and the Privacy Policy to continue.",
    "mustAcceptPd": "To continue, accept the Terms of Use and give consent to the processing of personal data.",
    "close": "Close"
  },
  "age": {
    "question18": "How old are you?",
    "is18": "I am 18 or older",
    "below18": "I am under 18",
    "question14": "Are you 14 or older?",
    "is14": "I am 14 or older",
    "below14": "I am under 14",
    "back": "Back",
    "change": "Change",
    "summaryAdult": "Age: 18 or older",
    "summaryTeen": "Age: 14 to 17",
    "under14Title": "You must be 14 to register",
    "under14Body": "We care about children's safety, so we can't create an account for anyone under 14. Come back when you're older — we'll be glad to see you.",
    "required": "Choose your age to continue"
  },
  "consentGate": {
    "title": "A couple of steps before you start",
    "body": "Confirm your age and accept the documents — we can't keep your data without it.",
    "updateTitle": "We have updated our documents",
    "updateBody": "The Terms of Use and the consent to personal data processing have changed. To keep using Agapella, please read and accept them — until then access to your account is limited.",
    "continue": "Continue",
    "logout": "Sign out",
    "error": "Couldn't save. Check your connection and try again.",
    "under14Removed": "The account has been deleted: you must be 14 to register."
  }
}
